module.exports = __webpack_public_path__ + "img/kk-back.11e8b2ea.png";